import { Nav, Navbar, NavDropdown, NavbarBrand } from 'react-bootstrap'
import { LinkContainer } from 'react-router-bootstrap'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { useKeycloak } from '@react-keycloak/web'
import { iconMatcher } from './matchers.jsx'
import { Icons } from './Icons.jsx'
import { useMenuConfig } from '../../api/domain/menu/queries/useMenuConfig.jsx'
import logo from '../../assets/logo.svg'
import CurrentUserInfo from './CurrentUserInfo.jsx'

const SideMenu = ({ menu, className, perms, side }) => {
    const safePerms = Array.isArray(perms) ? perms : [];

    return (
        <>
            <Nav
                className={` ${className} d-flex flex-row gap23 align-items-center justify-content-center flex-wrap`}
            >
                {menu.map((item, idx) => {
                    const key = Object.keys(item)[0]
                    const { label, icon, submenu, perms: itemPerms } = item[key]

                    if (
                        itemPerms &&
                        itemPerms.mode !== 'pass' &&
                        !itemPerms?.list?.some((p) => safePerms?.includes(p))
                    )
                        return null

                    return (
                        <NavDropdown
                            align={side === 'lewe' ? 'start' : 'end'}
                            key={idx}
                            title={iconMatcher[icon]?.icon || label}
                            id={`collapsible-nav-dropdown-${idx}`}
                        >
                            {submenu &&
                                submenu.map((subItem, subIdx) =>
                                    Object.keys(subItem).map(
                                        (subKey, subKeyIdx) => {
                                            const {
                                                label: subLabel,
                                                perms: subItemPerms,
                                                icon,
                                                to,
                                                href,
                                            } = subItem[subKey]

                                            if (
                                                subItemPerms &&
                                                subItemPerms.mode !== 'pass' &&
                                                !subItemPerms?.list?.some((p) =>
                                                    safePerms?.includes(p)
                                                )
                                            )
                                                return null
                                            const linkItem = (
                                                <NavDropdown.Item>
                                                    {iconMatcher[icon]?.icon ||
                                                        subLabel}
                                                </NavDropdown.Item>
                                            )
                                            const link = href ? (
                                                <div
                                                    onClick={() => {
                                                        window.open(
                                                            href,
                                                            '_blank'
                                                        )
                                                    }}
                                                >
                                                    {linkItem}
                                                </div>
                                            ) : (
                                                <LinkContainer
                                                    key={`${subIdx}-${subKeyIdx}`}
                                                    to={to}
                                                >
                                                    {linkItem}
                                                </LinkContainer>
                                            )

                                            return <>{link}</>
                                        }
                                    )
                                )}
                        </NavDropdown>
                    )
                })}
            </Nav>
        </>
    )
}

SideMenu.propTypes = {
    menu: PropTypes.array.isRequired,
    className: PropTypes.string,
    perms: PropTypes.array,
    side: PropTypes.string.isRequired,
}

export const Top = ({ type }) => {
    const role = useSelector((state) => state.user.role)
    const username = useSelector((state) => state.user.preferred_username)
    const profil_id = useSelector((state) => state.user.profilId)
    const slownik_unit_id = useSelector((state) => state.user.user?.slownik_unit_id)
    const { keycloak } = useKeycloak()

    const perms = useSelector((state) => state.user.permissions)
    const menuConfig = useMenuConfig(type)

    const sides = [
        { key: 'lewe', className: 'me-auto' },
        { key: 'prawe', className: 'ms-auto' },
    ]

    // Get environment from Vite env variable
    const nodeEnv = import.meta.env.VITE_NODE_ENV || import.meta.env.MODE
    const envLabel = nodeEnv === 'test' ? 'test env, ' : nodeEnv === 'development' ? 'dev env, ' : ''
    const showInfo = ['development', 'test', 'local'].includes(nodeEnv)

    return (
        <>
            {showInfo && (
                <div
                    className={'fw-bold'}
                    style={{
                        position: 'sticky',
                        top: '65px',
                        right: '10px',
                        color: 'red',
                        fontSize: '.8rem',
                    }}
                >
                    {envLabel}rola: {role?.toUpperCase()} {username} |
                    profil_Id: {profil_id}
                </div>
            )}

            <Navbar
                fixed='top'
                bg='primary'
                variant='light'
                collapseOnSelect
                expand='md'
                style={{ minHeight: '55px' }}
            >
                <LinkContainer to={'/'}>
                    <NavbarBrand>
                        <img
                            width={80}
                            className={'ms-3 d-inline-block align-top'}
                            src={logo}
                            alt='Logo'
                        />
                    </NavbarBrand>
                </LinkContainer>

                <Navbar.Toggle aria-controls='responsive-navbar-nav' />
                <Navbar.Collapse id='responsive-navbar-nav'>
                    {menuConfig.data && (
                        <>
                            {sides.map((side, idx) => {
                                const { key, className } = side
                                return (
                                    <SideMenu
                                        side={key}
                                        key={idx}
                                        perms={perms}
                                        className={className}
                                        menu={
                                            menuConfig.data[`menu-${type}`][key]
                                        }
                                    />
                                )
                            })}
                        </>
                    )}
                    <Nav>
                        {(slownik_unit_id || profil_id?.startsWith('D')) && (
                            <Nav.Link
                                title={'Pomoc'}
                                onClick={() => window.open('https://slaskie365.sharepoint.com/sites/epw', '_blank')}
                            >
                                <Icons.help title={'Pomoc'} size={26} />
                            </Nav.Link>
                        )}
                        <Nav.Link
                            title={'Wyloguj się'}
                            onClick={() => keycloak.logout()}
                        >
                            <Icons.exit title={'Wyloguj się'} size={26} />
                        </Nav.Link>
                    </Nav>
                </Navbar.Collapse>
            </Navbar>

            <div
                style={{
                    position: 'fixed',
                    top: '56px',
                    right: '8px',
                    zIndex: 10,
                }}
            >
                <CurrentUserInfo/>
            </div>
        </>
    )
}

Top.propTypes = {
    type: PropTypes.string.isRequired,
}
